export default "__VITE_ASSET__BYbq4z8G__"